import { MediaImage } from '@/elements/media-image/media-image.component';

import { Container, InnerContainer, Top, Text, Name, About } from './lecturer-card.elements';

const LecturerCard = ({ lecturer }) => {
  return (
    <Container>
      <InnerContainer>
        <Top>
          <MediaImage
            variant="lecturer"
            src={lecturer.profileImage?.sizes?.lecturerCard?.url}
            width={260}
            height={146}
            alt={lecturer.profileImage?.alt || `${lecturer.firstName} ${lecturer.lastName}`}
            style={{ objectFit: 'cover', maxWidth: '100%' }}
          />
        </Top>
        <Text>
          <Name>
            {lecturer.firstName} {lecturer.lastName}
          </Name>
          <About>{lecturer.qualifications}</About>
        </Text>
      </InnerContainer>
    </Container>
  );
};

export { LecturerCard };
